import React, { useEffect } from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import { copyToClipboard } from 'Helpers/Utils';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';

const styles = () => ({
  root: {},
});

const CopyToClipboardButton = ({ string }) => {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setOpen(false), 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [open]);

  function handleClick() {
    setOpen(true);
    copyToClipboard(string);
  }

  return (
    <div>
      <Tooltip
        open={open}
        title="Copied"
        placement="top"
      >
        <IconButton
          aria-label="copy to clipboard"
          size="small"
          onClick={() => handleClick()}
        >
          <FontAwesome icon="clipboard" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

CopyToClipboardButton.defaultProps = {
  string: undefined,
};

CopyToClipboardButton.propTypes = {
  string: PropTypes.string,
};

export default withStyles(styles)(CopyToClipboardButton);
